// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import {
  Trash2,
  Grid,
  Target,
  Settings,
  List,
  TreePine,
  ChevronDown,
} from "lucide-react";
import { tools, PARK_OBJECTS } from "../../utils/scenarioEditorUtils";

export default function Toolbar({
  tool,
  setTool,
  showParkObjectsDropdown,
  setShowParkObjectsDropdown,
  rightPanel,
  setRightPanel,
  toggleRightPanel,
  showRightPanel,
  deleteSelected,
  hasSelection,
  showGrid,
  setShowGrid,
  snapToGrid,
  setSnapToGrid,
}) {
  return (
    <div className="min-w-[64px] w-16 flex-shrink-0 bg-white dark:bg-slate-800 border-r border-gray-200 dark:border-slate-700 flex flex-col items-center py-2 space-y-2 overflow-y-auto">
      {tools.map((toolItem) => (
        <button
          key={toolItem.id}
          onClick={() => setTool(toolItem.id)}
          className={`p-2 rounded-lg transition-colors ${
            tool === toolItem.id
              ? "bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400"
              : "text-gray-600 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-600"
          }`}
          title={toolItem.label}
        >
          <toolItem.icon className="w-5 h-5" />
        </button>
      ))}
      <div className="relative">
        <button
          onClick={() => setShowParkObjectsDropdown(!showParkObjectsDropdown)}
          className={`p-2 rounded-lg transition-colors flex items-center ${
            Object.keys(PARK_OBJECTS).includes(tool)
              ? "bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400"
              : "text-gray-600 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-600"
          }`}
          title="Park Objects"
        >
          <TreePine className="w-4 h-4" />
          <ChevronDown className="w-2 h-2 ml-1" />
        </button>
        {showParkObjectsDropdown && (
          <div className="absolute left-full ml-2 top-0 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-600 rounded-lg shadow-lg z-50 w-48">
            <div className="p-2 space-y-1">
              <div className="text-xs text-gray-500 dark:text-slate-400 font-semibold px-2 py-1">
                Park Objects
              </div>
              {Object.entries(PARK_OBJECTS).map(([key, object]) => (
                <button
                  key={key}
                  onClick={() => {
                    setTool(key);
                    setShowParkObjectsDropdown(false);
                  }}
                  className={`w-full flex items-center gap-2 px-2 py-2 rounded text-sm transition-colors ${
                    tool === key
                      ? "bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400"
                      : "text-gray-700 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-600"
                  }`}
                >
                  <object.icon className="w-4 h-4" />
                  {object.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="border-t border-gray-200 dark:border-slate-700 pt-2 mt-4 space-y-2 text-center">
        <button
          onClick={() =>
            setRightPanel(rightPanel === "objects" ? "properties" : "objects")
          }
          className={`p-2 rounded-lg transition-colors ${
            rightPanel === "objects"
              ? "bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400"
              : "text-gray-600 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-600"
          }`}
          title="Objects Panel"
        >
          <List className="w-5 h-5" />
        </button>
        <button
          onClick={toggleRightPanel}
          className={`p-2 rounded-lg transition-colors ${
            showRightPanel
              ? "bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400"
              : "text-gray-600 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-600"
          }`}
          title="Toggle Right Panel (L)"
        >
          <Settings className="w-5 h-5" />
        </button>
        <button
          onClick={deleteSelected}
          disabled={!hasSelection}
          className="p-2 rounded-lg text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 disabled:text-gray-400 dark:disabled:text-slate-500 disabled:hover:bg-transparent dark:disabled:hover:bg-transparent"
          title="Delete Selected"
        >
          <Trash2 className="w-5 h-5" />
        </button>
        <button
          onClick={() => setShowGrid(!showGrid)}
          className={`p-2 rounded-lg transition-colors ${
            showGrid
              ? "bg-gray-100 dark:bg-slate-600 text-gray-700 dark:text-slate-300"
              : "text-gray-600 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-600"
          }`}
          title="Toggle Grid"
        >
          <Grid className="w-5 h-5" />
        </button>
        <button
          onClick={() => setSnapToGrid(!snapToGrid)}
          className={`p-2 rounded-lg transition-colors ${
            snapToGrid
              ? "bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400"
              : "text-gray-600 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-600"
          }`}
          title="Snap to Grid"
        >
          <Target className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
